export default {
    "showDev": {
        name: "Show developer links in navigations",
        options: [{ key: true, value: "Enabled" }, { key: false, value: "Disabled" }]
    },
    "accDeletion": {
        name: "Account deletion",
        options: [{ key: true, value: "Enabled" }, { key: false, value: "Disabled" }]
    },
    "accOauth": {
        name: "OAuth Providers",
        options: [{ key: true, value: "Enabled" }, { key: false, value: "Disabled" }]
    },
    "importEntire": {
        name: "Import Entire CTF",
        options: [{ key: true, value: "Enabled" }, { key: false, value: "Disabled" }]
    },
    "advSearch": {
        name: "Advanced Team/Member Search",
        options: [{ key: true, value: "Enabled" }, { key: false, value: "Disabled" }]
    },
    "leaderboardReload": {
        name: "Live Leaderboard Reload",
        options: [{ key: false, value: "Disabled" }, { key: true, value: "Enabled" }]
    },
    "layoutDebug": {
        name: "Display Layout Debug",
        options: [{ key: false, value: "Disabled" }, { key: true, value: "Enabled" }]
    },
};
